<template>
	<v-container fluid class="rmp-alerts ma-0 pa-0 px-md-8 px-3 pb-7 d-flex justify-end align-end flex-column"
				 style="position: fixed; bottom: 0; row-gap: 8px; pointer-events: none; z-index: 100" 
				 :style="$vuetify.breakpoint.lgAndUp ? `width: calc(100% - ${substractionWidth}px)` : ''">
		<rmp-alerts-snackbar :text="successAlert.text"
							 @close="onCloseSuccessAlert(index)"
							 right
							 type="success"
							 icon="ico_success"
							 :class="{ 'mt-4': !index }"
							 :timeout="successAlert.timeout"
							 v-for="(successAlert, index) in successAlerts"
							 :key="`success-${index}`">
		</rmp-alerts-snackbar>
		<rmp-alerts-snackbar :text="infoAlert.text"
							 @close="onCloseInfoAlert(index)"
							 right
							 type="info"
							 icon="ico_info"
							 :class="{ 'mt-4': !index }"
							 :timeout="infoAlert.timeout"
							 v-for="(infoAlert, index) in infoAlerts"
							 :key="`info-${index}`">
		</rmp-alerts-snackbar>
		<rmp-alerts-snackbar :text="errorAlert.text"
							 @close="onCloseErrorAlert(index)"
							 right
							 type="error"
							 icon="ico_error"
							 :class="{ 'mt-4': !index }"
							 :timeout="errorAlert.timeout"
							 v-for="(errorAlert, index) in errorAlerts"
							 :key="`error-${index}`">
		</rmp-alerts-snackbar>
	</v-container>
</template>

<script setup lang="ts">
import RmpAlertsSnackbar from "@rmp/core/components/alerts/RmpAlertsSnackbar.vue";
import { useAlertsStore } from "@rmp/core/stores/alerts";
import { storeToRefs } from "pinia";

interface Props {
	substractionWidth?: number | string;
}

withDefaults(defineProps<Props>(), {
	substractionWidth: 234
})


const useStore = useAlertsStore;
const store = useStore();
const { removeErrorAlert: onCloseErrorAlert, removeInfoAlert: onCloseInfoAlert, removeSuccessAlert: onCloseSuccessAlert } = useStore();

const { errorAlerts, infoAlerts, successAlerts } = storeToRefs(store);
</script>

<style lang="less">
.v-application:has(.rmp-fixed-actions) .rmp-alerts {
	padding-bottom: 72px !important;
}

.v-application:has(.rmp-master-account-actions) .rmp-alerts {
	padding-bottom: 100px !important;
}
</style>